// // 

// import React, { useState } from "react";
// import CustomButton from "../../../../atoms/CustomButton";
// import { CheckCheck, Edit, Trash2 } from "lucide-react";
// import Modal from "../../../../organisms/modals/Modal";
// import { useCookies } from "react-cookie";
// import { Field, Form, Formik } from "formik";
// import { postData, patchData } from "../../../../../services";
// import toast from "react-hot-toast";
// import { confimationStyles, errorStyles } from "../../../../../assets/styles/toast";
// import * as Yup from "yup";
// import Error from "../../../../atoms/Error";
// import InputLayout from "../../../../atoms/InputLayout";
// import {
//   AttachmentComponent,
//   UploadedFilesComponent,
// } from "../../../../organisms/AttachmentComponent";

// const SubtaskForm = ({
//   setOpen,
//   prevData,
//   setPrevData,
//   task_id,
//   initialValues,
//   refetchData,
//   dirtyFlag,
//   setSubtaskOpen
// }) => {
//   const [cookies] = useCookies(["euid"]);
//   const [isUploading, setIsUploading] = useState(false);

//   // console.log("This is is uploading:",isUploading)

//   const initialData = {
//     id: initialValues?.id || null,
//     title: initialValues?.title || "",
//     description: initialValues?.description || "",
//     media: initialValues?.media || [],
//   };

//   const validationSchema = Yup.object().shape({
//     title: Yup.string().required("Task Title is required"),
//   });

//   const handleSubmit = async (values, { resetForm }) => {
//     const subtaskData = {
//       title: values.title,
//       description: values.description,
//       media: values.media,
//       status: values.status || "New Task",
//     };

//     try {
//       if (values.id) {
//         // Editing an existing subtask
//         if (values.id.toString().startsWith("temp-")) {
//           // Update temporary subtask locally
//           setPrevData((prev) => ({
//             ...prev,
//             subtasks: prev.subtasks.map((item) =>
//               item.id === values.id ? { ...item, ...subtaskData } : item
//             ),
//           }));
//           toast.success("Subtask Updated", {
//             style: confimationStyles,
//             duration: 1000,
//           });
//           if (dirtyFlag) dirtyFlag(true);
//         } else if (task_id) {
//           // Update existing subtask on server
//           const res = await patchData({
//             endpoint: "Subtask/updateSubtask",
//             data: { ...subtaskData, task_id: task_id },
//             token: cookies.e_t || cookies.euid, // Use consistent cookie key
//             params: { id: values.id },
//           });
//           setPrevData((prev) => ({
//             ...prev,
//             subtasks: prev.subtasks.map((item) =>
//               item.id === values.id ? res.data : item
//             ),
//           }));
//           toast.success("Subtask Updated Successfully", {
//             style: confimationStyles,
//             duration: 1000,
//           });
//           if (refetchData) refetchData();
//           if (dirtyFlag) dirtyFlag(true);
//         }
//       } else {
//         // Creating a new subtask
//         if (task_id) {
//           // Create new subtask on server
//           const res = await postData({
//             endpoint: "Subtask/createSubtask",
//             data: [{ ...subtaskData, taskId: task_id }],
//             token: cookies.e_t || cookies.euid, // Use consistent cookie key
//           });
//           setPrevData((prev) => ({
//             ...prev,
//             subtasks: [...prev.subtasks, res?.data?.data?.[0]],
//           }));
//           toast.success("Subtask Created Successfully", {
//             style: confimationStyles,
//             duration: 1000,
//           });
//           if (refetchData) refetchData();
//           if (dirtyFlag) dirtyFlag(true);
//         } else {
//           // Create new temporary subtask locally
//           const newSubtask = {
//             id: `temp-${Date.now()}`,
//             ...subtaskData,
//           };
//           setPrevData((prev) => ({
//             ...prev,
//             subtasks: [...prev.subtasks, newSubtask],
//           }));
//           toast.success("Subtask Added", {
//             style: confimationStyles,
//             duration: 1000,
//           });
//           if (dirtyFlag) dirtyFlag(true);
//         }
//       }
//       resetForm();
//       setSubtaskOpen(false);
//     } catch (err) {
//       console.error("API Error:", err);
//       toast.error("Error Saving Subtask", { style: errorStyles });
//     }
//   };

//   return (
//     <div>
//       <Formik
//         initialValues={initialData}
//         validationSchema={validationSchema}
//         enableReinitialize
//         validateOnMount={false}
//         validateOnChange={true}
//         validateOnBlur={true}
//         onSubmit={handleSubmit}
//       >
//         {({
//           values,
//           setFieldValue,
//           handleChange,
//           isSubmitting,
//           resetForm,
//           isValid,
//           errors,
//           touched,
//           dirty,
//         }) => (
//           <Form>
//             <div className="d-flex flex-column mb-3">
//               <label className="required-field">Task Title</label>
//               <div className="w-100">
//                 <InputLayout>
//                   <Field name="title" />
//                   {touched.title && errors.title && <Error error={errors.title} />}
//                 </InputLayout>
//               </div>
//             </div>

//             <div className="d-flex flex-column mb-3">
//               <label className="">Description</label>
//               <textarea
//                 name="description"
//                 id="description"
//                 value={values?.description}
//                 onChange={(e) => setFieldValue("description", e.target.value)}
//                 className="w-100"
//               ></textarea>
//             </div>

//             <div>
//               <AttachmentComponent
//                 onUploadComplete={(s3Links) => {
//                   setFieldValue("media", [...values.media, ...s3Links]);
//                 }}
//                 onFileRemove={(removedLink) => {
//                   setFieldValue(
//                     "media",
//                     values.media.filter((link) => link !== removedLink)
//                   );
//                 }}
//                 initialAttachments={values.media.map((link, index) => ({
//                   id: index,
//                   name: `File ${index + 1}`,
//                   s3Link: link,
//                 }))}
//                 alreadyAdded={values?.media}
//                 setUploadingState={setIsUploading}
//               />
//             </div>

//             {values?.media?.length > 0 && (
//               <div className="mt-3">
//                 <label htmlFor="">Attachments</label>
//                 <UploadedFilesComponent
//                   alreadyAdded={values?.media}
//                   onFileRemove={(removedLink) => {
//                     setFieldValue(
//                       "media",
//                       values.media.filter((link) => link !== removedLink)
//                     );
//                   }}
//                 />
//               </div>
//             )}

//             <div className="modal-footer mt-4 px-4">
//               <button
//                 type="button"
//                 className="btn btn-outline-primary"
//                 onClick={() => {
//                   setOpen(false);
//                   setPrevData((prev) => ({ ...prev, editingSubtask: null }));
//                 }}
//               >
//                 Cancel
//               </button>
//               <button type="submit" 
//               className="btn btn-primary"
//               disabled={isSubmitting || isUploading || !isValid || !dirty}
//               >
//                 {initialValues?.id ? "Update" : "Save"}
//               </button>
//             </div>
//           </Form>
//         )}
//       </Formik>
//     </div>
//   );
// };

// export default SubtaskForm;


import React, { useState } from "react";
import CustomButton from "../../../../atoms/CustomButton";
import { CheckCheck, Edit, Trash2 } from "lucide-react";
import Modal from "../../../../organisms/modals/Modal";
import { useCookies } from "react-cookie";
import { Field, Form, Formik } from "formik";
import { postData, patchData } from "../../../../../services";
import toast from "react-hot-toast";
import { confimationStyles, errorStyles } from "../../../../../assets/styles/toast";
import * as Yup from "yup";
import Error from "../../../../atoms/Error";
import InputLayout from "../../../../atoms/InputLayout";
import {
  AttachmentComponent,
  UploadedFilesComponent,
} from "../../../../organisms/AttachmentComponent";
// NEW IMPORT: Add DateSelector for the due_date field (same as in TaskForm)
import { DateSelector } from "../../../../organisms/MonthYearSelector"; // Adjust path if needed
import moment from "moment"; // For date formatting/display if needed

const SubtaskForm = ({
  setOpen,
  prevData,
  setPrevData,
  task_id,
  initialValues,
  refetchData,
  dirtyFlag,
  setSubtaskOpen
}) => {
  const [cookies] = useCookies(["euid"]);
  const [isUploading, setIsUploading] = useState(false);

  // UPDATED: Add due_date to initialData
  const initialData = {
    id: initialValues?.id || null,
    title: initialValues?.title || "",
    description: initialValues?.description || "",
    due_date: initialValues?.due_date || null, // NEW: Default to null or existing value
    media: initialValues?.media || [],
  };

  // UPDATED: Add due_date to validationSchema (optional)
  const validationSchema = Yup.object().shape({
    title: Yup.string().required("Task Title is required"),
    due_date: Yup.date().nullable(), // NEW: Optional date validation
  });

  const handleSubmit = async (values, { resetForm }) => {
    // UPDATED: Include due_date in subtaskData
    const subtaskData = {
      title: values.title,
      description: values.description,
      due_date: values.due_date, // NEW: Send due_date to API
      media: values.media,
      status: values.status || "New Task",
    };

    try {
      if (values.id) {
        // Editing an existing subtask
        if (values.id.toString().startsWith("temp-")) {
          // Update temporary subtask locally
          setPrevData((prev) => ({
            ...prev,
            subtasks: prev.subtasks.map((item) =>
              item.id === values.id ? { ...item, ...subtaskData } : item
            ),
          }));
          toast.success("Subtask Updated", {
            style: confimationStyles,
            duration: 1000,
          });
          if (dirtyFlag) dirtyFlag(true);
        } else if (task_id) {
          // Update existing subtask on server
          const res = await patchData({
            endpoint: "Subtask/updateSubtask",
            data: { ...subtaskData, task_id: task_id }, // due_date is now in subtaskData
            token: cookies.e_t || cookies.euid,
            params: { id: values.id },
          });
          setPrevData((prev) => ({
            ...prev,
            subtasks: prev.subtasks.map((item) =>
              item.id === values.id ? res.data : item
            ),
          }));
          toast.success("Subtask Updated Successfully", {
            style: confimationStyles,
            duration: 1000,
          });
          if (refetchData) refetchData();
          if (dirtyFlag) dirtyFlag(true);
        }
      } else {
        // Creating a new subtask
        if (task_id) {
          // Create new subtask on server
          const res = await postData({
            endpoint: "Subtask/createSubtask",
            data: [{ ...subtaskData, taskId: task_id }], // due_date is now in subtaskData
            token: cookies.e_t || cookies.euid,
          });
          setPrevData((prev) => ({
            ...prev,
            subtasks: [...prev.subtasks, res?.data?.data?.[0]],
          }));
          toast.success("Subtask Created Successfully", {
            style: confimationStyles,
            duration: 1000,
          });
          if (refetchData) refetchData();
          if (dirtyFlag) dirtyFlag(true);
        } else {
          // Create new temporary subtask locally
          const newSubtask = {
            id: `temp-${Date.now()}`,
            ...subtaskData, // due_date included here too
          };
          setPrevData((prev) => ({
            ...prev,
            subtasks: [...prev.subtasks, newSubtask],
          }));
          toast.success("Subtask Added", {
            style: confimationStyles,
            duration: 1000,
          });
          if (dirtyFlag) dirtyFlag(true);
        }
      }
      resetForm();
      setSubtaskOpen(false);
    } catch (err) {
      console.error("API Error:", err);
      toast.error("Error Saving Subtask", { style: errorStyles });
    }
  };

  return (
    <div>
      <Formik
        initialValues={initialData}
        validationSchema={validationSchema}
        enableReinitialize
        validateOnMount={false}
        validateOnChange={true}
        validateOnBlur={true}
        onSubmit={handleSubmit}
      >
        {({
          values,
          setFieldValue,
          handleChange,
          isSubmitting,
          resetForm,
          isValid,
          errors,
          touched,
          dirty,
        }) => (
          <Form>
            <div className="d-flex flex-column mb-3">
              <label className="required-field">Task Title</label>
              <div className="w-100">
                <InputLayout>
                  <Field name="title" />
                  {touched.title && errors.title && <Error error={errors.title} />}
                </InputLayout>
              </div>
            </div>

            <div className="d-flex flex-column mb-3">
              <label className="">Description</label>
              <textarea
                name="description"
                id="description"
                value={values?.description}
                onChange={(e) => setFieldValue("description", e.target.value)}
                className="w-100"
              ></textarea>
            </div>

            {/* NEW: Add Due Date field, similar to TaskForm */}
            <div className="d-flex flex-column mb-3">
              <label className="">Due Date</label>
              <div className="w-100">
                <InputLayout>
                  <DateSelector
                    selectedDate={values.due_date} // Bind to form value
                    onChange={(date) => {
                      // Convert to UTC like in TaskForm
                      const istDate = new Date(date);
                      const utcDate = new Date(
                        istDate.getTime() - istDate.getTimezoneOffset() * 60000
                      );
                      setFieldValue("due_date", utcDate.toISOString());
                    }}
                    handleBlur={() => {}} // Optional: Add touched logic if needed
                    disablePast={true} // Adjust based on your logic (e.g., allow past for admins)
                    isError={touched.due_date && errors.due_date}
                  />
                  {touched.due_date && errors.due_date && <Error error={errors.due_date} />}
                </InputLayout>
              </div>
            </div>

            <div>
              <AttachmentComponent
                onUploadComplete={(s3Links) => {
                  setFieldValue("media", [...values.media, ...s3Links]);
                }}
                onFileRemove={(removedLink) => {
                  setFieldValue(
                    "media",
                    values.media.filter((link) => link !== removedLink)
                  );
                }}
                initialAttachments={values.media.map((link, index) => ({
                  id: index,
                  name: `File ${index + 1}`,
                  s3Link: link,
                }))}
                alreadyAdded={values?.media}
                setUploadingState={setIsUploading}
              />
            </div>

            {values?.media?.length > 0 && (
              <div className="mt-3">
                <label htmlFor="">Attachments</label>
                <UploadedFilesComponent
                  alreadyAdded={values?.media}
                  onFileRemove={(removedLink) => {
                    setFieldValue(
                      "media",
                      values.media.filter((link) => link !== removedLink)
                    );
                  }}
                />
              </div>
            )}

            <div className="modal-footer mt-4 px-4">
              <button
                type="button"
                className="btn btn-outline-primary"
                onClick={() => {
                  setOpen(false);
                  setPrevData((prev) => ({ ...prev, editingSubtask: null }));
                }}
              >
                Cancel
              </button>
              <button 
                type="submit" 
                className="btn btn-primary"
                disabled={isSubmitting || isUploading || !isValid || !dirty}
              >
                {initialValues?.id ? "Update" : "Save"}
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default SubtaskForm;